import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../../models/utilities/list-header";
import { PageData } from "../../../models/utilities/paged-request";
import { ApiEndpoints } from "../../../utils/app-constants";

export class CreditHoldSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(10000);
    public baseUrl          : string = ApiEndpoints.ORDERING_CREDIT_HOLD;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('Dealer Name', 'dealer', true),
            new ListColumn('Subtotal', 'subtotal', true),
            new ListColumn('Freight', 'freight', true),
            new ListColumn('Tax', 'tax', true),
            new ListColumn('Total', 'total', true)
        ];

        // Create our Filter Groups
        const byCutoff = this.buildCutoff();
        const byDealer = this.buildDealer();
        const byOrder = this.buildOrder();
        const byCreation = this.buildMaxCreationDate();
                
        this.filters.push(
            byCutoff, byDealer, byOrder, byCreation
        );

    }

    // #region Group Builders
    private buildCutoff() {
        const byDate = new FilterGroup('Cutoff', 'dateplus', 'maxCutoff');        
        const opt1 = new FilterBarInputOpt('Cutoff', {
            selectedDate: {
                qsValue: new Date(),
                qsName: 'maxCutoff'
            },
            checkboxValue: {
                qsValue: true,
                qsName: 'matchDayOfWeek'
            }
        });
        
        byDate.opts = [opt1];

        return byDate;
    }

    private buildDealer() {
        const byDealer = new FilterGroup('Dealer', 'dealer', 'dealerId');        
        const opt1 = new FilterBarInputOpt('Dealer', '');
        
        byDealer.opts = [opt1];

        return byDealer;
    }

    private buildOrder() {
        const byOrderId = new FilterGroup('Order ID', 'text', 'orderId');
        const opt1 = new FilterBarInputOpt('Order ID', '');
        
        byOrderId.opts = [opt1];

        return byOrderId;
    }
    
    private buildMaxCreationDate() {
        const byDate = new FilterGroup('Max Creation Date', 'date', 'maxCreationDate');        
        const opt1 = new FilterBarInputOpt('Max Creation Date', undefined);
        
        byDate.opts = [opt1];

        return byDate;
    }
    
    // #endregion

}
